import { Box, Typography } from '@mui/material';
import { Tag } from '@care/react-component-lib';
import { getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_providerSearchResults as SEOSegmentationProviderSearchResult } from '@/__generated__/getSearchResults';
import getProviderHighlights from '@/utils/getProviderHighlights';

export interface ProviderHighlightsProps {
  attributes: SEOSegmentationProviderSearchResult['seniorAssistedLivingCenterAttributes'];
}

const ProviderHighlights = ({ attributes }: ProviderHighlightsProps) => {
  const highlights = getProviderHighlights(attributes);

  if (!highlights.length) {
    return null;
  }
  return (
    <Box alignItems="center" mt={1.5}>
      <Typography component="span" variant="body2" fontWeight="700">
        Highlights:{' '}
      </Typography>
      {highlights.map((value) => {
        return (
          <Typography component="span" mr={1} key={`highlights-tag-${value}`}>
            <Tag type="green">{value}</Tag>
          </Typography>
        );
      })}
    </Box>
  );
};

export default ProviderHighlights;
